export interface DictionariesModel {
  code: string;
  name: string;
  id: number;
}
